module.exports = __webpack_public_path__ + "img/content1-bg.222eb096.png";